<template>
  <div :key="tender.id" style="cursor: pointer;"
       class="cursor-pointer d-flex flex-column tender-item-block padding-10">
    <div class="position-relative">
      <div v-if="canFavorite" class="button-favorite" @click.stop="(e) => {toggleFavorite(tender)}">
      <svg v-if="tender.is_favorite" width="19" height="18" viewBox="0 0 19 18" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.5 0.500006C9.26336 0.499292 9.03123 0.563843 8.82987 0.686358C8.62852 0.808874 8.46596 0.984467 8.36058 1.19328L6.26998 5.38223L1.58348 6.05597C1.34992 6.08986 1.13059 6.18733 0.950179 6.33741C0.769773 6.48749 0.635455 6.68421 0.562344 6.90544C0.489234 7.12666 0.480233 7.36361 0.536357 7.58961C0.59248 7.8156 0.711498 8.02167 0.880014 8.18462L4.26856 11.4362L3.46601 16.0352C3.43598 16.2145 3.44568 16.3981 3.49442 16.5733C3.54317 16.7486 3.62981 16.9114 3.74841 17.0505C3.86701 17.1897 4.01475 17.3019 4.1815 17.3794C4.34824 17.457 4.53004 17.4981 4.71442 17.4999C4.92211 17.5026 5.12696 17.4522 5.3089 17.3534L9.5 15.1467L13.6911 17.3144C13.8696 17.4127 14.0712 17.4632 14.2757 17.4608C14.4609 17.4604 14.6438 17.4204 14.8118 17.3434C14.9797 17.2665 15.1287 17.1545 15.2484 17.0152C15.3681 16.8758 15.4556 16.7126 15.5049 16.5366C15.5542 16.3607 15.5641 16.1763 15.534 15.9962L14.7314 11.3971L18.12 8.14556C18.2885 7.98261 18.4075 7.77654 18.4636 7.55055C18.5198 7.32455 18.5108 7.08761 18.4377 6.86638C18.3645 6.64515 18.2302 6.44843 18.0498 6.29835C17.8694 6.14828 17.6501 6.05081 17.4165 6.01691L12.73 5.38223L10.6394 1.19328C10.534 0.984467 10.3715 0.808874 10.1701 0.686358C9.96877 0.563843 9.73664 0.499292 9.5 0.500006Z"
            fill="#006BE6" />
      </svg>
      <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 2.23808L10.8924 6.02668L11.2392 6.71995L12.012 6.82736L16.2527 7.44252L13.1812 10.3719L12.6263 10.9089L12.7551 11.6705L13.4784 15.8399L9.68365 13.8871L8.99009 13.5355L8.29653 13.8871L4.50175 15.8399L5.22504 11.6705L5.35385 10.9089L4.799 10.3719L1.7176 7.44252L5.93842 6.82736L6.71125 6.71995L7.05803 6.02668L9 2.23808ZM9 0.500006C8.76336 0.499292 8.53123 0.563843 8.32987 0.686358C8.12852 0.808874 7.96596 0.984467 7.86058 1.19328L5.76998 5.38223L1.08348 6.05597C0.849917 6.08986 0.630585 6.18733 0.450179 6.33741C0.269773 6.48749 0.135455 6.68421 0.0623442 6.90544C-0.0107664 7.12666 -0.0197666 7.36361 0.0363566 7.58961C0.0924798 7.8156 0.211498 8.02167 0.380014 8.18462L3.76856 11.4362L2.96601 16.0352C2.93598 16.2145 2.94568 16.3981 2.99442 16.5733C3.04317 16.7486 3.12981 16.9114 3.24841 17.0505C3.36701 17.1897 3.51475 17.3019 3.6815 17.3794C3.84824 17.457 4.03004 17.4981 4.21442 17.4999C4.42211 17.5026 4.62696 17.4522 4.8089 17.3534L9 15.1467L13.1911 17.3144C13.3696 17.4127 13.5712 17.4632 13.7757 17.4608C13.9609 17.4604 14.1438 17.4204 14.3118 17.3434C14.4797 17.2665 14.6287 17.1545 14.7484 17.0152C14.8681 16.8758 14.9556 16.7126 15.0049 16.5366C15.0542 16.3607 15.0641 16.1763 15.034 15.9962L14.2314 11.3971L17.62 8.14556C17.7885 7.98261 17.9075 7.77654 17.9636 7.55055C18.0198 7.32455 18.0108 7.08761 17.9377 6.86638C17.8645 6.64515 17.7302 6.44843 17.5498 6.29835C17.3694 6.14828 17.1501 6.05081 16.9165 6.01691L12.23 5.38223L10.1394 1.19328C10.034 0.984467 9.87148 0.808874 9.67013 0.686358C9.46877 0.563843 9.23664 0.499292 9 0.500006Z"
            fill="#40444D" />
      </svg>
    </div>
    <carousel :perPage="1"
              :navigationEnabled="true"
              :loop="true"
              :scrollPerPage="true"
              :navigationPrevLabel="prevLabel"
              :navigationNextLabel="nextLabel"
    >
      <slide :key="picture" v-for="(picture, index) in tender.pictures" :class="index === 0 && 'VueCarousel-slide-active'" class="position-relative h-100">
        <img class="tender-item-slide-img" @click="$emit('click')" :src="`${backendUrl}/uploads/${picture}`">
      </slide>
    </carousel>
  </div>
  <p class="name">
    {{ tender.name }}
  </p>
  <div class="d-flex flex-row justify-content-between">
    <div class="price-block">
      <template v-if="tender.lowest_price && tender.market_price">
        <span class="small market-price"><del>{{tender.market_price}}</del></span>
        <span class="small text-primary font-weight-bold">
          -{{ ((tender.market_price - tender.lowest_price) / tender.market_price * 100).toFixed(2) }}%
        </span>
        <p class="price">
          {{ tender.lowest_price }}դր
        </p>
      </template>
      <template v-else>
        <p class="price">
          {{ tender.market_price }}դր
        </p>
      </template>
    </div>
    <div class="d-flex justify-content-center align-content-center">
      <template v-if="canEdit">
        <span v-tooltip="'Խմբագրել'" @click="(e) => {e.stopPropagation();$router.push(`/timeless-tenders/buy/edit/${tender.id}`)}">
          <svg class="mr-2" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.95199 7.61638L13.5648 2L14.5076 2.9434L8.89479 8.55978L7.95199 7.61638ZM3.84113 12.6213L12.241 12.6658L12.2766 7.3291H13.6188V12.4434C13.6188 13.2973 12.9165 13.9999 12.0632 13.9999H4.06335C3.20114 13.9999 2.50781 13.2973 2.50781 12.4434V4.4384C2.50781 3.58453 3.21002 2.88187 4.06335 2.88187H8.46328V4.24272L3.88557 4.21604L3.84113 12.6213Z"
                  fill="#006BE6" />
          </svg>
        </span>
        <template v-if="me.id === 6798">
          <span v-tooltip="'Հեռացնել'" @click="(e) => {e.stopPropagation();deleteTender(tender.id)}">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.11768 0H11.3877V1.5H5.11768V0ZM0.507812 3.29004H16.0078V4.79004H14.5078V15.59C14.5052 16.0534 14.32 16.497 13.9923 16.8246C13.6647 17.1522 13.2211 17.3374 12.7578 17.34H3.75781C3.29368 17.34 2.84856 17.1557 2.52038 16.8275C2.19219 16.4993 2.00781 16.0542 2.00781 15.59V4.79004H0.507812V3.29004ZM3.50781 15.79L12.9578 15.84L12.9978 4.79004H3.50781V15.79Z"
                  fill="#E02232" />
            </svg>
          </span>
          <span v-if="!tender.is_confirmed" class="ml-2 text-success" v-tooltip="'Հաստատել'" @click="(e) => {e.stopPropagation();confirmTender(tender.id)}">
            <i style="font-size: 17px;" class="fa-solid fa-check"></i>
          </span>
        </template>
      </template>
    </div>
  </div>
  <span class="text-small text-success" v-if="showIsConfirmed(tender)"><small>Հրապարակված է</small></span>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  props: ['tender', 'canEdit', 'canFavorite', 'selectedType', 'refreshList'],
  components: { Carousel, Slide },
  data() {
    return {
      dateNow: new Date(),
      backendUrl: process.env.VUE_APP_URL,
      columns: [
        'password',
        'title',
        'products',
        'opening_finish_date',
        'price',
        'region',
        'type',
        'invitation',
        'edit',
        'participants_count',
      ],
      prevLabel: `<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.7069 5.41936L7.2931 2.98443e-07L9 1.65591L3.41379 7.07527L9 12.3441L7.29311 14L1.7069 8.73118L1.23708e-06 7.07527L1.7069 5.41936Z" fill="white"/>
</svg>`,
      nextLabel: `<svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.7931 5.41935L2.2069 -2.98443e-07L0.5 1.65591L6.08621 7.07527L0.500002 12.3441L2.2069 14L7.7931 8.73118L9.5 7.07527L7.7931 5.41935Z" fill="white"/>
</svg>`,
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    }
  },
  methods: {
    showIsConfirmed(tender){
      console.log('tender', tender)
      if(this.$route.path.includes('admin')){
        console.log('HERE', tender)

        return (this.me.id === tender.user_id) && tender.is_confirmed;
      }
      return false;
    },
    selectPage(event) {
      this.$router.push(event.target.value)
    },
    deleteTender(id) {
      this.$client.delete(`timeless-tenders/${id}`).then(({ data }) => {
        this.$emit('refreshList')
      })
    },
    confirmTender(id) {
      this.$client.post(`timeless-tenders/confirm/${id}`).then(({ data }) => {
        this.$emit('refreshList')
      })
    },
    toggleFavorite(tender) {
      const data = {
        timeless_tender_id: tender.id,
        type: this.selectedType,
      }
      if (tender.is_favorite) {
        this.$client.post(`timeless-tenders/removeFavorite`, data).then(({ data }) => {
          this.getTenders()
        })
        this.tender.is_favorite = false
      } else {
        this.$client.post(`timeless-tenders/addFavorite`, data).then(({ data }) => {
          this.getTenders()
        })
        this.tender.is_favorite = true
      }
    },
  },
}
</script>

<style scoped>
.button-favorite {
  position: absolute;
  right: 12px;
  top: 12px;
  background: white;
  border-radius: 50%;
  z-index: 99;
  padding: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tender-item-block{
  width: calc(100% / 4);
}

.enlarge-menu .tender-item-block {
  width: calc(100% / 5);
}

.tender-item-block * {
  max-width: 100%;
}

.tender-item-block p {
  border-radius: 6px;
}

.tender-item-block .name {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 8px 0;
}

.tender-item-block .code {
  font-size: 14px;
  font-weight: 300;
  color: #595E6B;
}

.tender-item-block .price {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

@media (max-width: 1324px) {
  .tender-item-block {
    width: calc(100% / 4) !important;
  }
}

@media (max-width: 1100px) {
  .tender-item-block {
    width: calc(100% / 3) !important;
  }
}

@media (max-width: 768px) {
  .tender-item-block {
    width: calc(100% / 2) !important;
  }
}

@media (max-width: 480px) {
  .tender-item-block {
    width: 100% !important;
  }
}
</style>
<style>
.tender-item-block{
  .VueCarousel {
    .VueCarousel-navigation {
      button {
        width: 32px !important;
        height: 48px !important;
        top: 75px !important;
        background: rgba(0, 0, 0, .25) !important;
        transform: none !important;
      }
    }

    .VueCarousel-inner{
      width: auto;
      flex: 0 0 100%;
      img {
        border-radius: 8px;
        height: 200px;
        width: 100%;
        flex: 0 0 100% !important;
      }
    }

    .tender-item-slide-img{
      flex: 0 0 100% !important;
    }
    .VueCarousel-slide.VueCarousel-slide-active{
      display: contents;
      opacity: 1;
    }
    .VueCarousel-slide{
      opacity: 0;
      //width: 100%;
    }



    .VueCarousel-pagination {
      .VueCarousel-dot-container {
        width: 100%;
        background: transparent;
        height: fit-content !important;
        position: absolute;
        right: 0;
        left: 0;
        bottom: 6px;
        margin: 0 auto !important;
        display: flex;
        justify-content: space-between; /* Spread buttons evenly */
        align-items: center;

        button {
          margin: 0 4px !important;
          flex: 1 1 auto; /* Allow each button to grow and shrink equally */
          max-width: 100%; /* Ensure buttons don’t exceed the container width */
          height: 2px !important;
          background: #EDEFF2;
          padding: 0 1px !important;
          border-radius: 0 !important;
        }

        .VueCarousel-dot--active {
          height: 4px !important;
          background: #006BE6 !important;
        }
      }
    }
  }
}
</style>

